import script from "./redbullView.vue?vue&type=script&setup=true&lang=js"
export * from "./redbullView.vue?vue&type=script&setup=true&lang=js"

import "./redbullView.vue?vue&type=style&index=0&id=0ac6f46f&lang=css"

const __exports__ = script;

export default __exports__